export default "__VITE_ASSET__J$sE7X6e__"